import { render, staticRenderFns } from "./updateWallet.vue?vue&type=template&id=1fd88322&"
import script from "./updateWallet.vue?vue&type=script&lang=js&"
export * from "./updateWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kolobox-admin/kolobox-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VContainer,VFlex,VForm,VLayout,VSelect,VSnackbar,VTextField})
